import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import './index.css';
import { syncQueue } from './lib/syncQueue';
import { chatDb } from './lib/chatDb';

// Initialize offline storage
syncQueue.init();
chatDb.init();

// Service Worker registration disabled (not implemented yet)
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/sw.js').then((registration) => {
//     console.log('Service Worker registered:', registration);
//   }).catch((error) => {
//     console.error('Service Worker registration failed:', error);
//   });
// }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
